module.exports = __webpack_public_path__ + "img/2_130.afd8b59e.png";